import React from 'react';
import styled from 'styled-components';
import { H3 } from '../../../Atoms/Typo';

const Component = styled.div`
  ${H3}
  font-size: 20px;
`;

interface TitleProps {
  title: string;
}

const Title = ({ title }: TitleProps) => {
  return <Component className="voda_chart_title">{title}</Component>;
};

export default Title;
